import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

const Blends = ({ setSearchQuery }) => {
  const banners = [
    {
      imgSrc: "../assets/images/ReducarbBlends/carbohydrate_blend.png",
      title: "Carbohydrate blend",
      subtitle: "Designed optimal carbohydrate to fiber ratio for slower sugar absorption avoiding sugar spikes and early satiety.",
    },
    {
      imgSrc: "../assets/images/ReducarbBlends/protein_blend.png",
      title: "Protein blend",
      subtitle: "Designed with dual protein blend beneficial in pre-diabetes, overweight, obesity and heart health.",
    },
    {
      imgSrc: "../assets/images/ReducarbBlends/fat_blend.png",
      title: "Fat blend",
      subtitle: "Designed with high Oleic acid rich in Polyunsaturated Fatty acids. ",
    },
    {
      imgSrc: "../assets/images/ReducarbBlends/vitamin_blend.png",
      title: "Vitamin Blend ",
      subtitle: "Designed with gender specific needs to provide 50% RDAs of key vitamins and minerals. ",
    },
    {
        imgSrc: "../assets/images/ReducarbBlends/fiber_blend.png",
        title: "Fiber blend",
        subtitle: "Designed with high and complex fibers for early satiety, slower absorption of sugars and gut health.",
      }
  ];

  const handleButtonClick = (title) => {
    setSearchQuery(title);
  };

  const sliderSettings = {
    dots: false, // Disable bottom dots
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000, // Autoplay every 3 seconds
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="banner-section banner-small  section-lg-space  ratio_65">

      <div className="container-fluid-lg">
      <div className="text-center mb-5">
            <h2 className="center font_Home_section mb-2 ">
            <span style={{color: 'var(--theme-color1)'}}>Redu</span><span style={{color: 'var(--theme-color)'}}>carb</span> Blends
            </h2>
            <p>Specially designed blend for nutrition well-being</p>
          </div>
        <Slider {...sliderSettings}>
          {banners.map((banner, index) => (
            <div key={index}>
              <div className="banner-contain-3 hover-effect" style={{ height: "350px", position: "relative" }}>
                <a
                  href="#"
                  className="bg-size"
                  style={{
                    backgroundImage: `url(${banner.imgSrc})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center center",
                    backgroundRepeat: "no-repeat",
                    display: "block",
                    height: "100%",
                  }}
                >
                  <img
                    src={banner.imgSrc}
                    className="img-fluid bg-img"
                    alt=""
                    style={{ display: "none" }}
                  />
                </a>
                <div className="banner-detail p-center-left w-75 banner-p-sm mend-auto" style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <div>
                    <h4 className="fw-bold ">{banner.title}</h4>
                    <div className="text-muted font-xsm my-2">{banner.subtitle}</div>
                  </div>
                  
                  <div style={{ position: "absolute", bottom: "20px", left: "20px" }}>
                    <Link to={`/reducarb-blends/${banner.title.split(' ')[0]}`}>
                      <button className="btn_get_started btns btn-animation-blue home-button">
                        Know more
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Blends;
